/**
 * Calendar API facade.
 *
 * When USE_MOCK is true, all calls are served by the in-memory mock.
 * Flip to false (or remove the mock entirely) once the backend is live.
 */
const USE_MOCK = false

import * as real from './calendarsReal'
import * as mock from './__mocks__/calendarsMock'

const impl = USE_MOCK ? mock : real

export const listCalendars = impl.listCalendars
export const getCalendar = impl.getCalendar
export const createCalendar = impl.createCalendar
export const updateCalendar = impl.updateCalendar
export const deleteCalendar = impl.deleteCalendar
export const copyCalendar = impl.copyCalendar

export const createCalendarEvent = impl.createCalendarEvent
export const updateCalendarEvent = impl.updateCalendarEvent
export const deleteCalendarEvent = impl.deleteCalendarEvent
export const reorderCalendarEvents = impl.reorderCalendarEvents

export const createMilestone = impl.createMilestone
export const updateMilestone = impl.updateMilestone
export const deleteMilestone = impl.deleteMilestone
export const reorderMilestones = impl.reorderMilestones

export const getCalendarGrid = impl.getCalendarGrid
export const listMilestoneRules = impl.listMilestoneRules

// Plan Calendar (no mock needed – direct re-export)
export {
  getPlanCalendar,
  assignPlanCalendar,
  detachPlanCalendar,
  listCalendarEvents,
} from './calendarsReal'

export type { ListCalendarsParams } from './calendarsReal'
